import { combineReducers } from 'redux'
// import * as types from './actions.js'
import menu from './menu/reducer'
import members from './members/reducer'
import dataExport from './data-export/reducer'

const enterpriseReducer = combineReducers({
  menu,
  dataExport,
  members
})

export default enterpriseReducer



// WEBPACK FOOTER //
// ./src/enterprise/reducer.js